import * as yup from 'yup';

const emailValidator = yup.string().email();

/**
 * Gates the domain lookup. RHF runs in onSubmit mode here, so formState.errors is still empty
 * while the user is typing and cannot be used to tell a complete email from a partial one.
 */
export const isValidEmail = (value?: string | null): boolean =>
  Boolean(value) && emailValidator.isValidSync(value);
